/* tslint:disable */
/* eslint-disable */
export enum UserAction {
  Unspecified = 'Unspecified',
  No = 'No',
  Yes = 'Yes'
}
